import AttendanceCard from './attendanceCard';
export default AttendanceCard;